const mycarResources = {
  en: {
    mycar: {
      title:
        'Application - questionnaire for voluntary motor vehicle insurance',
      title2:
        'Application - questionnaire for voluntary motor vehicle insurance and title insurance',
      policyholder: 'Policyholder',
      iin: 'IIN',
      fullName: 'Full Name',
      idCard: 'Identity Document',
      insured: 'Insured',
      insuranceObject: 'Insurance Object',
      insuranceConditions: 'Insurance Conditions',
      insuranceAmount: 'Insurance Amount',
      insurancePremium: 'Insurance Premium',
      conclusionDate: 'Conclusion Date',
      insuranceTerm: 'Insurance Term',
      confirm: 'Confirm',
      carNumber: 'Vehicle State number',
      newCar: 'New car',
      yes: 'Yes',
      no: 'No',
      mark: 'Mark',
      model: 'Model',
      issueYear: 'Year of issue',
    },
  },
  kz: {
    mycar: {
      title:
        'Автомобиль көлігін ерікті сақтандыруға арналған өтініш-сауалнамасы',
      title2:
        'Автомобиль көлігін ерікті сақтандыру және титулдық сақтандыру бойынша өтініш – сауалнама',
      policyholder: 'Сақтанушы',
      iin: 'ЖСН',
      fullName: 'Аты-жөні',
      idCard: 'Жеке куәлік',
      insured: 'Сақтандырылғандар',
      insuranceObject: 'Сақтандыру объектісі',
      insuranceConditions: 'Сақтандыру шарттары',
      insuranceAmount: 'Сақтандыру сомасы',
      insurancePremium: 'Сақтандыру сыйақысы',
      conclusionDate: 'Қорытындылау күні',
      insuranceTerm: 'Сақтандыру мерзімі',
      confirm: 'Растау',
      carNumber: 'Көлік нөмірі',
      newCar: 'Жаңа көлік',
      yes: 'Иә',
      no: 'Жоқ',
      mark: 'Марка',
      model: 'Модель',
      issueYear: 'Шығарылған жыл',
    },
  },
  ru: {
    mycar: {
      title:
        'Заявление – анкета по добровольному страхованию автомобильного транспорта',
      title2:
        'Заявление – анкета по добровольному страхованию автомобильного транспорта и титульного страхования',
      policyholder: 'Страхователь',
      iin: 'ИИН',
      fullName: 'ФИО',
      idCard: 'Удостоверение личности',
      insured: 'Застрахованные',
      insuranceObject: 'Объект страхования',
      insuranceConditions: 'Условия страхования',
      insuranceAmount: 'Страховая сумма',
      insurancePremium: 'Страховая премия',
      conclusionDate: 'Дата заключения',
      insuranceTerm: 'Срок страхования',
      confirm: 'Подтвердить',
      carNumber: 'Гос. Номер ТС',
      newCar: 'Новый автомобиль',
      yes: 'Да',
      no: 'Нет',
      mark: 'Марка',
      model: 'Модель',
      issueYear: 'Год выпуска',
    },
  },
};

export default mycarResources;
